import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';

import { safeConvertToUUID } from 'uuid-encoding';
import { getTenantDetailsQuery } from 'graphql-queries';


export const useFetchTenant = (
  channelId: string | undefined,
  tenantId: string
) => {
  const [fetchTenant, { data, error }] = useLazyQuery(
    getTenantDetailsQuery,
    {
      fetchPolicy: 'network-only',
    }
  );

  useEffect(() => {
    if (channelId && tenantId) {
      fetchTenant({
        variables: {
          propertyId: safeConvertToUUID(channelId),
          tenantId: safeConvertToUUID(tenantId),
        },
      });
    }
  }, [channelId, tenantId, fetchTenant]);

  return {
    data,
    error,
  };
};
